import { Link } from 'react-router-dom';
import { PPP_VS_GENERIC_3PL_ROWS } from '../../data/brandHomeData';
import './BrandWhySection.css';

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="why-ppp-check-icon">
    <circle cx="12" cy="12" r="10" fill="#FF7900"/>
    <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CrossIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="why-ppp-cross-icon">
    <circle cx="12" cy="12" r="10" fill="#F1F5F9"/>
    <path d="M15 9L9 15M9 9L15 15" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const BoxIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
);

const TruckIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
);

const ChartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
);

const PeopleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
);


const capIcons = [
  <BoxIcon />,
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>,
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>,
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><circle cx="10" cy="13" r="2"></circle><line x1="11.4" y1="14.4" x2="15" y2="18"></line></svg>,
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
];

export default function BrandWhySection() {
  return (
    <section className="why-ppp-redesign" aria-labelledby="brand-why-heading">
      <div className="why-ppp-top">
        <div className="why-ppp-container">
          
          {/* LEFT SIDE CONTENT */}
          <div className="why-ppp-left">
            <div className="why-ppp-subtitle">
              <span className="why-ppp-dash"></span>
              WHY PICK PACK PRO
            </div>
            
            <h2 id="brand-why-heading" className="why-ppp-title">
              Fulfilment built <br/> <span className="why-ppp-highlight">around your growth</span>
            </h2>
            
            <p className="why-ppp-desc">
              We are a Milton Keynes-based Amazon FBA prep centre and 3PL, built for eCommerce brands that need compliant prep, SFP-ready dispatch and clear, transparent pricing, not a one-size-fits-all warehouse.
            </p>
            
            <div className="why-ppp-features">
              <div className="why-ppp-feature"><BoxIcon /> <span>Specialist FBA prep</span></div>
              <div className="why-ppp-feature"><TruckIcon /> <span>UK-wide dispatch</span></div>
              <div className="why-ppp-feature"><ChartIcon /> <span>650+ integrations</span></div>
              <div className="why-ppp-feature"><PeopleIcon /> <span>Built for growing brands</span></div>
            </div>
            
            <Link to="/contact-fulfillment-services" className="why-ppp-cta">
              Get a fulfilment quote &rarr;
            </Link>
          </div>
          
          {/* RIGHT SIDE TABLE */}
          <div className="why-ppp-right">
            <div className="why-ppp-table-card">
              <div className="why-ppp-thead">
                <div className="why-ppp-th why-ppp-th-cap">CAPABILITY</div>
                <div className="why-ppp-th why-ppp-th-gen">TYPICAL GENERIC 3PL</div>
                <div className="why-ppp-th why-ppp-th-pro">
                  <img src="/Images/ppp-orange-logo-wide.png" alt="Pick Pack Pro" className="why-ppp-th-logo" />
                </div>
              </div>
              
              <div className="why-ppp-tbody">
                {PPP_VS_GENERIC_3PL_ROWS.map((row, i) => (
                  <div className="why-ppp-tr" key={i}>
                    <div className="why-ppp-td why-ppp-td-cap">
                      <div className="why-ppp-cap-icon">{capIcons[i]}</div>
                      <span>{row.feature}</span>
                    </div>
                    <div className="why-ppp-td why-ppp-td-gen">
                      <CrossIcon />
                      <span>{row.generic}</span>
                    </div>
                    <div className="why-ppp-td why-ppp-td-pro">
                      <CheckIcon />
                      <span>{row.ppp}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
        </div>
      </div>
      
      {/* BOTTOM IMAGE STRIP REMOVED */}

      {/* --- OLD COMMENTED OUT CODE --- */}
      {/*
      <div className="brand-why-container" style={{ display: 'none' }}>
        <div className="brand-why-head">
          <h2 id="brand-why-heading" className="brand-why-title">
            Why choose Pick Pack Pro over generic 3PLs?
          </h2>
          <p className="brand-why-lead">
            <strong>Answer:</strong> Pick Pack Pro provides 99.9% picking accuracy, 7-day SFP dispatch, and transparent published FBA prep pricing from 30p/unit?"unlike generic 3PLs that lack dedicated marketplace compliance.
          </p>
        </div>

        <div className="brand-why-table-wrap" tabIndex={0} role="region" aria-label="Pick Pack Pro vs generic 3PL comparison">
          <table className="brand-why-table">
            <thead>
              <tr>
                <th scope="col">Capability</th>
                <th scope="col">Typical generic 3PL</th>
                <th scope="col">Pick Pack Pro</th>
              </tr>
            </thead>
            <tbody>
              {PPP_VS_GENERIC_3PL_ROWS.map((row) => (
                <tr key={row.feature}>
                  <th scope="row">{row.feature}</th>
                  <td>{row.generic}</td>
                  <td>{row.ppp}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="brand-why-foot">
          <Link to="/about-our-fulfillment-company">About our UK fulfilment company</Link>
          {' A '}
          <Link to="/case-studies">Client success stories</Link>
        </p>
      </div>
      */}
    </section>
  );
}

